import { useActiveOrganization } from "@/core/context/ActiveOrganizationContext"
import Relay from "@/relay/relayUtils"
import {
  DiscoButtonColor,
  DiscoButtonSkeleton,
  DiscoButtonVariant,
  DiscoModal,
} from "@disco-ui"
import {
  OverridableDiscoButton,
  OverridableDiscoButtonChildren,
} from "@disco-ui/button/OverridableDiscoButton"
import usePermissions from "@utils/hook/usePermissions"
import { TestIDProps } from "@utils/typeUtils"
import TrainingSourceSettingsForm from "./TrainingSourceSettingsForm"
import { TrainingSourceKind } from "./__generated__/TrainingSourceSettingsFormFragment.graphql"

interface CreateTrainingSourceButtonProps extends TestIDProps {
  children?: OverridableDiscoButtonChildren
  variant?: DiscoButtonVariant
  kind?: TrainingSourceKind
  color?: DiscoButtonColor
}

function CreateTrainingSourceButton({
  testid = "CreateTrainingSourceButton",
  children = "Add Training Source",
  variant = "outlined",
  kind = "web_crawl",
  color = "grey",
}: CreateTrainingSourceButtonProps) {
  const activeOrganization = useActiveOrganization()
  const permissions = usePermissions(activeOrganization)
  const canManage = permissions.has("training_sources.manage")
  if (!canManage) return null

  return (
    <OverridableDiscoButton
      modal={({ isOpen, onClose }) => {
        if (!isOpen) return null

        return (
          <DiscoModal
            testid={testid}
            modalContentLabel={"Add Training Source Modal"}
            title={`Add ${kind === "web_crawl" ? "Link" : "Knowledge Base"}`}
            isOpen
            onClose={onClose}
            buttons
            width={"520px"}
            body={
              <TrainingSourceSettingsForm
                onSubmit={onClose}
                onClose={onClose}
                kind={kind}
              />
            }
          />
        )
      }}
      color={color}
      variant={variant}
      leftIcon={"add"}
      width={"100%"}
    >
      {children}
    </OverridableDiscoButton>
  )
}

export default Relay.withSkeleton({
  skeleton: () => <DiscoButtonSkeleton width={"100%"} />,
  component: CreateTrainingSourceButton,
})
